import { render, staticRenderFns } from "./FlowUsageStatistics.vue?vue&type=template&id=3b564985&scoped=true&"
import script from "./FlowUsageStatistics.vue?vue&type=script&lang=js&"
export * from "./FlowUsageStatistics.vue?vue&type=script&lang=js&"
import style0 from "./FlowUsageStatistics.vue?vue&type=style&index=0&id=3b564985&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b564985",
  null
  
)

export default component.exports